import { css } from "@emotion/css";
import useTheme from "@common/hooks/useTheme";

const useStyles = () => {
  const theme = useTheme();

  // Same panel and title row as the project services page
  // (ProjectServicesV2/common/style.css: .projectServicesV2, .projectServicesHeader).
  const page = css`
    background: #fff;
    padding: 15px;
    border: 1px solid #d7d7d7;
    border-radius: 4px;
    box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.15);
  `;

  const header = css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #d7d7d7;
    margin-bottom: 16px;
    padding-bottom: 10px;
    h1 {
      color: #1c2655;
      font-weight: 800;
      font-size: 24px;
      margin: 0;
    }
  `;

  const headerActions = css`
    display: flex;
    align-items: center;
    gap: 12px;
  `;

  const subline = css`
    color: ${theme.colors.navy["3"]};
    font-size: 14px;
  `;

  const banner = css`
    background: ${theme.colors.yellow["1"]}33;
    border: 1px solid ${theme.colors.yellow.primary};
    border-radius: 6px;
    padding: 12px 16px;
    margin-bottom: 16px;
    color: ${theme.colors.navy["1"]};
  `;

  const card = css`
    background: ${theme.colors.white};
    border: 1px solid ${theme.colors.gray["3"]};
    border-radius: 8px;
    padding: 24px;
    margin-bottom: 16px;
  `;

  const emptyCard = css`
    text-align: center;
    max-width: 640px;
    margin: 32px auto;
    h2 {
      font-size: 22px;
      font-weight: 700;
      color: ${theme.colors.navy["1"]};
      margin-bottom: 12px;
    }
    p {
      color: ${theme.colors.navy["3"]};
      margin-bottom: 20px;
    }
  `;

  const gradeCard = css`
    ${card};
    display: flex;
    align-items: center;
    gap: 24px;
  `;

  const gradeLetter = css`
    font-size: 56px;
    font-weight: 700;
    line-height: 1;
    min-width: 72px;
    text-align: center;
    color: ${theme.colors.teal["1"]};
  `;

  const gradeBody = css`
    flex: 1;
  `;

  const score = css`
    font-size: 18px;
    font-weight: 700;
    color: ${theme.colors.navy["1"]};
  `;

  const progressTrack = css`
    height: 8px;
    border-radius: 4px;
    background: ${theme.colors.gray["5"]};
    overflow: hidden;
    margin: 12px 0 4px;
  `;

  const progressFill = css`
    height: 100%;
    background: ${theme.colors.teal["2"]};
  `;

  const todoHeader = css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    h2 {
      font-size: 18px;
      font-weight: 700;
      color: ${theme.colors.navy["1"]};
      margin: 0;
    }
  `;

  const todoCategory = css`
    font-size: 13px;
    font-weight: 700;
    text-transform: uppercase;
    color: ${theme.colors.navy["3"]};
    margin: 16px 0 6px;
  `;

  const todoRow = css`
    display: flex;
    align-items: baseline;
    gap: 8px;
    padding: 4px 0;
    margin: 0;
    label {
      margin: 0;
      flex: 1;
    }
  `;

  const todoDone = css`
    text-decoration: line-through;
    color: ${theme.colors.navy["3"]};
  `;

  const pill = css`
    font-size: 11px;
    font-weight: 700;
    border-radius: 10px;
    padding: 1px 8px;
    color: ${theme.colors.white};
    white-space: nowrap;
  `;

  const linkButton = css`
    background: none;
    border: 0;
    padding: 0;
    color: ${theme.colors.navy["1"]};
    font-weight: 600;
  `;

  const hint = css`
    color: ${theme.colors.navy["3"]};
    font-size: 14px;
    margin: 4px 0 12px;
  `;

  const suggestionRow = css`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 0;
    border-top: 1px solid ${theme.colors.gray["5"]};
    &:first-of-type {
      border-top: 0;
    }
  `;

  const suggestionBody = css`
    flex: 1;
    min-width: 0;
  `;

  const suggestionName = css`
    font-weight: 600;
    color: ${theme.colors.navy["1"]};
    margin-right: 8px;
  `;

  const suggestionActions = css`
    display: flex;
    gap: 8px;
    flex-shrink: 0;
  `;

  return {
    hint,
    suggestionRow,
    suggestionBody,
    suggestionName,
    suggestionActions,
    todoHeader,
    todoCategory,
    todoRow,
    todoDone,
    pill,
    linkButton,
    page,
    header,
    headerActions,
    subline,
    banner,
    card,
    emptyCard,
    gradeCard,
    gradeLetter,
    gradeBody,
    score,
    progressTrack,
    progressFill,
  };
};

export default useStyles;
